import MxGraphFactory from 'mxgraph';
import {defaultBundle} from './defaultBundle';

const mxGraphFactory = new MxGraphFactory();
mxGraphFactory.mxResources.loadDefaultBundle = false;
mxGraphFactory.mxResources.parse(Object.keys(defaultBundle).map(key => `${key}=${defaultBundle[key]}`).join('\n'));

export const {
    mxCell,
    mxCellEditor,
    mxCellHighlight,
    mxCellMarker,
    mxCellOverlay,
    mxCellRenderer,
    mxPopupMenuHandler,
    mxCellState,
    mxClient,
    mxClipboard,
    mxConnectionConstraint,
    mxConnectionHandler,
    mxConnector,
    mxConstants,
    mxConstraintHandler,
    mxDictionary,
    mxDragSource,
    mxEdgeHandler,
    mxEdgeStyle,
    mxElbowEdgeHandler,
    mxEllipse,
    mxEvent,
    mxEventObject,
    mxEventSource,
    mxGeometry,
    mxGraph,
    mxGraphHandler,
    mxGraphModel,
    mxGraphView,
    mxGuide,
    mxHierarchicalLayout,
    mxImage,
    mxImageExport,
    mxImageShape,
    mxKeyHandler,
    mxLayoutManager,
    mxMouseEvent,
    mxObjectCodec,
    mxOutline,
    mxPanningHandler,
    mxPoint,
    mxPolyline,
    mxPopupMenu,
    mxRectangle,
    mxCellPath,
    mxRectangleShape,
    mxResources,
    mxRubberband,
    mxShape,
    mxStackLayout,
    mxStencil,
    mxStencilRegistry,
    mxStylesheet,
    mxSvgCanvas2D,
    mxText,
    mxUndoManager,
    mxUtils,
    mxVertexHandler,
    mxWindow
} = mxGraphFactory;
